import { useId } from 'react';
import { PercentageBar } from '../percentage-bar/percentage-bar';

interface TopConsumptionItemProps {
  name: string;
  value: string;
  percentage: string;
}

export function TopConsumptionItem({ name, value, percentage }: TopConsumptionItemProps) {
  const id = useId();
  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-between gap-2 text-white">
        <span>{name}</span>
        <span>{value}</span>
      </div>
      <PercentageBar key={id} className="h-[0.5em]" value={percentage} />
    </div>
  );
}
